import { Cell } from '../../../utils/Cell';
import { type CrewCompositions } from '../model/CrewCompositionTypes';
import { type PerformanceProfile } from '../model/PerformanceProfileTypes';
import { type Resource } from '../types';

export const AIRCRAFT_RESOURCES = new Cell<Resource[]>([]);
export const AIRCRAFT_PERFORMANCE_PROFILES = new Cell<
    Array<{ aircraftId: string; performanceProfile: PerformanceProfile | undefined }>
>([]);
export const CREW_COMPOSITION_RESOURCES = new Cell<
    Array<{ aircraftId: string; crewComposition: CrewCompositions | undefined }>
>([]);

export const cancelledLegsItemFields = `
      id
      reservationId
      eventId
      replacedByEventId
      replacedByReservationId
      status
      createdAt
      _version
      _deleted
      _lastChangedAt
      updatedAt
`;

export const customFilterFields = `
id
userId
name
createdAt
filterData
_version
_deleted
_lastChangedAt
updatedAt
`;

export const quotationItemsWithoutResourcesFields = `
id
createdAt
deleted
isActive
dateFrom
dateTo
quotationData
quotationCalculation
paxData
isExternal
contactId
quotationCode
isDutyPreview
_version
_deleted
_lastChangedAt
updatedAt
`;

export const reservationResourceItemFields = `
      id
      title
      type
      reservationId
      aircraftId
      contactId
      externalId
      created
      reservationDateTo
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
`;

export const quotationResourceItemFields = `
      id
      title
      type
      quotationId
      aircraftId
      contactId
      externalId
      created
      _version
      _deleted
      _lastChangedAt
      createdAt
      updatedAt
`;

export const quotationStateFields = `
        id
        state
        _version
`;

export const reservationItemWithoutResourcesFields = `
id
createdAt
deleted
isActive
dateFrom
dateTo
reservationData
paxData
isExternal
contactId
reservationCode
_version
_deleted
_lastChangedAt
updatedAt
quotationId
opsCancelled
`;

export const reservationPaxVersionItemFields = `
      id
      createdAt
      createdByUserId
      exportedAt
      paxData
      state
      reservationId
      eventId
      _version
      _deleted
      _lastChangedAt
      updatedAt
`;

export const getReservationFields = /* GraphQL */ `
    query GetReservation($id: ID!) {
        getReservation(id: $id) {
            id
            createdAt
            deleted
            dateFrom
            dateTo
            contactId
            isExternal
            reservationData
            paxData
            reservationCode
            _version
        }
    }
`;

export const reservationResourceDeleteFields = `
  id
  deleted
    _version
`;

export const getQuotationFields = /* GraphQL */ `
    query GetQuotation($id: ID!) {
        getQuotation(id: $id) {
            id
            createdAt
            deleted
            dateFrom
            dateTo
            contactId
            isExternal
            quotationData
            quotationCalculation
            paxData
            quotationCode
            _version
        }
    }
`;
